import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";

export default function SearchResults() {
  const location = useLocation();
  const navigate = useNavigate();

  const [results, setResults] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const params = new URLSearchParams(location.search);
  const [imageIndexes1, setImageIndexes1] = useState({});
  const nextImage1 = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/houserentdetails/${item.id}`);
      return;
    }

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage1 = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current === 0) return;

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  const query = params.get("query");
  const type = params.get("type");

  /* ================= LOAD WISHLIST ================= */

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user) {
      const saved =
        JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
      setWishlist(saved);
    }
  }, []);
  const [imageIndexes, setImageIndexes] = useState({});
  const nextImage = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/productdetails/${item.id}`);
      return;
    }

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current === 0) return;

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  /* ================= SYNC WISHLIST ================= */

  useEffect(() => {
    const syncWishlist = () => {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
        setWishlist(saved);
      }
    };

    window.addEventListener("cartUpdated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  /* ================= TOGGLE WISHLIST ================= */

  const toggleWishlist = (item) => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      navigate("/login");
      return;
    }

    const itemType = item.type === "workspace" ? "house" : item.type;

    const exists = wishlist.some(
      (w) => w.id === item.id && w.type === itemType,
    );

    let updated;

    if (exists) {
      updated = wishlist.filter(
        (w) => !(w.id === item.id && w.type === itemType),
      );
    } else {
      updated = [...wishlist, { ...item, type: itemType }];
    }

    setWishlist(updated);

    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(updated));

    window.dispatchEvent(new Event("cartUpdated"));
  };

  /* ================= FETCH ================= */

  useEffect(() => {
    fetch(`${API.SEARCH}&query=${query}&type=${type}`)
      .then((res) => res.json())
      .then((data) => setResults(data))
      .catch((err) => console.log(err));
  }, [query, type]);

  /* ================= UI ================= */

  return (
    <div className="container-fluid py-4">
      <div className="row">
        {/* ================= LEFT ================= */}

        <div className="col-lg-12">
          <div className="mb-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-light back-btn"
            >
              <i className="bi bi-arrow-left"></i> Back
            </button>
          </div>

          <h4 className="mb-4">
            Search Results for :<span className="text-primary"> {query}</span>
          </h4>

          <div className="designs-grid1">
            {results.length > 0 ? (
              results.map((item) => {
                const images = item.image ? item.image.split(",") : [];

                const checkType =
                  item.type === "workspace" ? "house" : item.type;

                const isLiked = wishlist.some(
                  (w) => w.id === item.id && w.type === checkType,
                );

                /* ================= MACHINE ================= */

                if (item.type === "machine") {
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/productdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className="machine-img-container"
                        onClick={() => navigate(`/productdetails/${item.id}`)}
                      >
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${
                            images[imageIndexes[item.id] || 0]
                          }?t=${Date.now()}`}
                          alt={item.machine_name}
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        <span className="heads-badge">
                          {item.NoOfHeads} Heads
                        </span>
                      </div>
                      <div className="machine-body">
                        <div className="machine-type">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>
                          {/* <button
                                                className="contact-btn"
                                                onClick={() =>
                                                  navigate(`/productdetails/${item.id}`)
                                                }
                                              >
                                                <i className="bi bi-telephone-fill me-1"></i>{" "}
                                                Contact
                                              </button> */}
                        </div>
                        <div className="spec-row mt-2 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Area:</span>
                            <span className="spec-value">{item.Area}</span>
                          </div>
                        </div>
                        <div className="spec-item mt-0 p-1">
                          <span className="spec-label1">
                            {" "}
                            <i className="bi bi-person-fill me-2"></i>
                            {item.name}
                          </span>
                        </div>
                        <div className="location-info mb-0 p-1">
                          <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                          {item.state}
                        </div>

                        <div className="machine-footer mt-0">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/productdetails/${item.id}`, {
                                state: {
                                  activeTab: "seller",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>
                            Contact Supplier
                          </button>
                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item, "machine");
                            }}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                /* ================= DESIGNER ================= */

                if (item.type === "designer") {
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/designerdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                          className="designer-img"
                          alt={item.name}
                          style={{
                            height: "100%",
                            objectFit: "cover",
                            width: "100%",
                          }}
                        />
                        {/* <span className="heads-badge">
                          {item.experience} Exp
                        </span> */}
                      </div>
                      <div className="machine-body">
                        <h4 className="machine-name">{item.name}</h4>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {item.expected_salary}
                            </span>
                            <span className="text-muted small"> / hr</span>
                          </div>
                        </div>
                        <div className="spec-row mt-0 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Skills:</span>
                            <span className="spec-value">{item.skills}</span>
                          </div>

                          <div className="spec-item">
                            <span className="spec-label">Exp:</span>
                            <span className="spec-value">
                              {item.experience}
                            </span>
                          </div>
                        </div>
                        <div className="location-info mt-1">
                          <i className="bi bi-geo-alt-fill text-secondary me-1"></i>{" "}
                          {item.location}
                        </div>
                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/designerdetails/${item.id}`, {
                                state: {
                                  activeTab: "contact",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-person-badge-fill me-2"></i>{" "}
                            Hire Now
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item);
                            }}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }
                /* ================= SKETCHER ================= */

                if (item.type === "sketcher") {
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/designerdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                          className="designer-img"
                          alt={item.name}
                          style={{
                            height: "100%",
                            objectFit: "cover",
                            width: "100%",
                          }}
                        />
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.name}</h4>

                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>

                            <span className="amount">
                              {item.expected_salary}
                            </span>

                            <span className="text-muted small"> / hr</span>
                          </div>
                        </div>

                        <div className="spec-row mt-0 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Skills:</span>
                            <span className="spec-value">{item.skills}</span>
                          </div>

                          <div className="spec-item">
                            <span className="spec-label">Exp:</span>
                            <span className="spec-value">
                              {item.experience}
                            </span>
                          </div>
                        </div>

                        <div className="location-info mt-1">
                          <i className="bi bi-geo-alt-fill text-secondary me-1"></i>
                          {item.location}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/designerdetails/${item.id}`, {
                                state: {
                                  activeTab: "contact",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-person-badge-fill me-2"></i>
                            Hire Now
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item);
                            }}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }
                /* ================= WORKSPACE ================= */

                if (item.type === "workspace") {
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/houserentdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[imageIndexes1[item.id] || 0]}`}
                          alt="workroom"
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes1[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage1(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage1(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        {/* <span className="heads-badge">{item.floor} </span> */}
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.location}</h4>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"> </span>
                          </div>
                        </div>

                        <div className="spec-row mt-3 mb-2">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            <span className="spec-value"> {item.size} </span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            <span className="spec-value"> {item.floor}</span>
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city},{item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/houserentDetails/${item.id}`, {
                                state: {
                                  activeTab: "ownerInfo",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact Owner
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item);
                            }}
                          >
                            <i
                              className={`bi ${
                                isLiked
                                  ? "bi-heart-fill text-danger"
                                  : "bi-heart"
                              }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                return null;
              })
            ) : (
              <h5>No Results Found</h5>
            )}
          </div>
        </div>
        <HorizontalAds />

        {/* ================= RIGHT ADS ================= */}

        {/* <div className="col-lg-2">
          <div className="ads-sidebar">
            <h5>Sponsored</h5>

            <div className="ad-card">
              <img src="/img/ad1.jpg" alt="" />
              <p>Best Embroidery Machines</p>
            </div>

            <div className="ad-card">
              <img src="/img/ad2.jpg" alt="" />
              <p>Find Workspaces</p>
            </div>

            <div className="ad-card">
              <img src="/img/ad3.jpg" alt="" />
              <p>Hire Skilled Designers</p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
